import { themed } from '@indeed/ifl-css';
import createResponsive from '../../utils/createResponsive.js';

const TEXT_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8];
const variants = {
  contrast: {
    color: "foreground.strong"
  },
  normal: {
    color: "foreground"
  },
  secondary: {
    color: "foreground.weak"
  },
  alert: {
    color: "foreground.status.critical"
  },
  success: {
    color: "foreground.status.success"
  }
};
const baseStyle = {
  fontFamily: "default",
  fontWeight: "inherit",
  color: "foreground"
};
const inheritStyle = {
  fontSize: "inherit",
  lineHeight: "inherit"
};
const getLevel = createResponsive(level => `text.level${level}`);
const base = _ref => {
  let {
    level,
    variant = "normal"
  } = _ref;
  return {
    ...baseStyle,
    ...variants[variant],
    ...(level !== undefined ? {
      variant: getLevel(level)
    } : inheritStyle)
  };
};

/**
 * @see https://experience.indeed.design/components/ids/text
 */
const Text = /*#__PURE__*/themed("span", process.env.NODE_ENV === "production" ? {
  styleProps: ["level", "variant"],
  shouldForwardProp: prop => prop !== "level" && prop !== "variant",
  target: "e1wnkr790"
} : {
  styleProps: ["level", "variant"],
  shouldForwardProp: prop => prop !== "level" && prop !== "variant",
  target: "e1wnkr790",
  label: "Text"
})(base, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const TEXT_VARIANTS = Object.keys(variants);
Text.displayName = "Text";

export { TEXT_LEVELS, TEXT_VARIANTS, Text };
